import { themed } from '@indeed/ifl-css';
import createResponsive from '../../utils/createResponsive.js';

const TEXT_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8];
const variants = {
  contrast: {
    color: "foreground.strong"
  },
  normal: {
    color: "foreground"
  },
  secondary: {
    color: "foreground.weak"
  },
  alert: {
    color: "foreground.status.critical"
  },
  success: {
    color: "foreground.status.success"
  }
};
const baseStyle = {
  fontFamily: "default",
  fontWeight: "inherit",
  color: "foreground"
};
const inheritStyle = {
  fontSize: "inherit",
  lineHeight: "inherit"
};
const getLevel = createResponsive(level => `text.level${level}`);
const base = _ref => {
  let {
    level,
    variant = "normal"
  } = _ref;
  return {
    ...baseStyle,
    ...variants[variant],
    ...(level !== undefined ? {
      variant: getLevel(level)
    } : inheritStyle)
  };
};

/**
 * @see https://experience.indeed.design/components/ids/text
 */
const Text = /*#__PURE__*/themed("span", process.env.NODE_ENV === "production" ? {
  styleProps: ["level", "variant"],
  shouldForwardProp: prop => prop !== "level" && prop !== "variant",
  target: "e1wnkr790"
} : {
  styleProps: ["level", "variant"],
  shouldForwardProp: prop => prop !== "level" && prop !== "variant",
  target: "e1wnkr790",
  label: "Text"
})(base, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const TEXT_VARIANTS = Object.keys(variants);
Text.displayName = "Text";

export { TEXT_LEVELS, TEXT_VARIANTS, Text };
